class AutomagicStep

    constructor: (opt) ->

        @wait = opt.wait ? null

        if typeof opt.when is 'function'
            @when = opt.when
        else
            @when = () -> return true

        # TODO: add event specification

        # if typeof opt.if is 'function'
        #     @if = opt.if
        # else
        #     @if = () -> return true


        @waitAnother = opt.waitAnother ? null

        if typeof opt.do is 'function'
            @do = opt.do
        else
            @do = () -> return true

        @maxWaitTime = opt.maxWaitTime ? 3000
        @pollInterval = opt.pollInterval ? 200
